import { SortDefinition } from '@shared/models/sort-definition';

export interface FormationObligatoireReglementaireState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: FormationObligatoireReglementaireState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'nom' },
};
